import { render, staticRenderFns } from "./AppNavbar2.vue?vue&type=template&id=5e54c7de"
import script from "./AppNavbar2.vue?vue&type=script&lang=ts"
export * from "./AppNavbar2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports